import { Button, Box } from "@mui/material";

export default function LoginButton() {
    return (
        <Box sx={{ flexGrow: 1 }}>
            {/* <Box sx={{ flexGrow: 1 }} justifyContent={'center'} textAlign={'center'}>
                <h2 style={{marginBottom: "20px"}}>Contribute to the Toolkit</h2>
            </Box> */}
            <p>Your contribution to this learning community is invaluable. Please consider sharing any tools that have helped you. To add tools to the toolkit you’ll need to create an account. The process is brief and free and we will never sell or share your information with third parties. For more details, please read our <a href={`${toolkitData.root_url}/terms-and-conditions/`}>terms and conditions</a>. </p>

            <p>To submit a tool you’ll provide your name, email address, a proposed title for the tool, a brief description of the tool, and a link or attachment to the tool itself. If possible, a link is preferred.  Prior to the tool being accepted for inclusion, a team of reviewers will assess the applicability and appropriateness of the submitted tool to the LHS Toolkit aims. Tools are reviewed on a quarterly basis.</p>

            <p>Please login to submit a new tool.</p>

            <Box sx={{ flexGrow: 1 }} justifyContent={'center'} textAlign={'center'}>
                <Button variant="contained" color="primary" sx={{ borderRadius: '24px' }} href={`${toolkitData.root_url}/wp-login.php`}>Login/Register</Button>
            </Box>
        </Box>
    );
}

